import { render, staticRenderFns } from "./milestone_dropdown.vue?vue&type=template&id=cac853c0"
import script from "./milestone_dropdown.vue?vue&type=script&lang=js"
export * from "./milestone_dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports